this.ringSizes = function() {

};

ringSizes.prototype.sizes = [
  {
    '14.9': {
      us: '4',
      uk: 'H',
      mm: '14.9'
    }
  },
  {
    '15.7': {
      us: '5',
      uk: 'J',
      mm: '15.7'
    }
  },
  {
    '16.5': {
      us: '6',
      uk: 'L',
      mm: '16.5'
    }
  },
  {
    '17.3': {
      us: '7',
      uk: 'N',
      mm: '17.3'
    }
  },
  {
    '18.1': {
      us: '8',
      uk: 'P',
      mm: '18.1'
    }
  },
  {
    '18.9': {
      us: '9',
      uk: 'R',
      mm: '18.9'
    }
  },
  {
    '19.8': {
      us: '10',
      uk: 'T',
      mm: '19.8'
    }
  },
  {
    '20.6': {
      us: '11',
      uk: 'V',
      mm: '20.6'
    }
  },
  {
    '21.4': {
      us: '12',
      uk: 'X',
      mm: '21.4'
    }
  },
  {
    '22.2': {
      us: '13',
      uk: 'Z',
      mm: '22.2'
    }
  },
];
//var current_site = document.getElementById('current-site').getAttribute('data-current-site');

window.dataLayer = window.dataLayer || [];

var ringSizes = new ringSizes();
ringSizes = ringSizes.sizes;

var ring = document.getElementById("ring");
var line = document.getElementById("line");

var isRingMeasure = false;
var isLineMeasure = false;

if(ring) isRingMeasure = true;
if(line) isLineMeasure = true;

// Default
let pixelsToMmRatio = 6.54;
const minScale = 0.6; // 0.7
const maxScale = 1.4; // 1.3

var pixelsToMmRatioCookie = window.localStorage.getItem('pixelsToMmRatio');
if(pixelsToMmRatioCookie) {
  pixelsToMmRatio = pixelsToMmRatioCookie;
}

// var debug = document.getElementById('debug');
// var debugPixelsToMmRatio = debug.querySelector('#pixelsToMm');
// debugPixelsToMmRatio.innerHTML = pixelsToMmRatio;

var calibration = document.getElementById("calibration");
var calibrationCard = document.getElementById("calibration-card");
var calibrationSlider = document.getElementById('calibrate-slider');
var calibrationCardPosRight = -320;

noUiSlider.create(calibrationSlider, {
    start: [50],
    step: 0.1,
    range: {
        'min': [0],
        'max': [100]
    }
});

calibrationSlider.noUiSlider.on('update', function (values) {
  const pixelHeightOfCard = calibrationCard.getBoundingClientRect().bottom - calibrationCard.getBoundingClientRect().top;
  // A debit card is 54mm tall
  if(!document.getElementById('step-2b').classList.contains('hidden')) {
    pixelsToMmRatio = pixelHeightOfCard / 54;
  }
  
  const percentage = values[0] / 100;
  const scale = (percentage * (maxScale - minScale)) + minScale;
  var cardCalculatedPosRight = calibrationCardPosRight + (-percentage * 240) + 'px';

  let value = values[0];
  //console.log({value, percentage, scale});

  calibrationCard.style.transform = `scale(${scale})`;
  calibrationCard.style.right = cardCalculatedPosRight;

  //debugPixelsToMmRatio.innerHTML = pixelsToMmRatio;
});

var ringGuide = document.getElementById("ring-guide");

var ringSlider = document.getElementById('ring-slider');
noUiSlider.create(ringSlider, {
    start: [50],
    step: 0.1,
    range: {
        'min': [0],
        'max': [100]
    }
});

var lineSlider = document.getElementById('line-slider');
noUiSlider.create(lineSlider, {
    start: [50],
    step: 0.1,
    range: {
        'min': [0],
        'max': [100]
    }
});

ringSlider.noUiSlider.on('update', function (values) {
  //console.log(values);
  const percentage = values[0] / 100;
  const scale = (percentage * (maxScale - minScale)) + minScale;

  //let currentScale = ring.style.transform.split('scale(')[1];
  //currentScale = parseFloat(currentScale.split('px)')[0]);
  // The new transformation
  //const transformation = `scale(${s ? s :currentScale})`;

  if(isRingMeasure) handleRing(scale);
});

ringSlider.noUiSlider.on('start', function() {
  // Remove hidden
  removeHiddenForSizes();
});

ringSlider.noUiSlider.on('slide', function() {
  // Make the buttons undisabled.
  document.getElementById('select-ring-size').classList.remove("pointer-events-none", "bg-opacity-30");
});

lineSlider.noUiSlider.on('update', function (values) {
  //console.log(values);
  const percentage = values[0] / 100;
  const scale = (percentage * (maxScale - minScale)) + minScale;

  //let currentScale = ring.style.transform.split('scale(')[1];
  //currentScale = parseFloat(currentScale.split('px)')[0]);
  // The new transformation
  //const transformation = `scale(${s ? s :currentScale})`;

  if(isLineMeasure) handleLine(scale);
});

lineSlider.noUiSlider.on('start', function() {
  // Remove hidden
  removeHiddenForLineSizes();
});

lineSlider.noUiSlider.on('slide', function() {
  // Make the buttons undisabled.
  document.getElementById('select-line-size').classList.remove("pointer-events-none", "bg-opacity-30");
});

function handleLine(scale)
{
  //console.log("handleLine");

  var el_ls = document.getElementById('ls-us');

  const transformation = `scale(${scale})`;
  line.style.transform = transformation;

  const ringDiam = line.getBoundingClientRect().bottom - line.getBoundingClientRect().top;
  const mm = (ringDiam / pixelsToMmRatio).toFixed(2);

  // Show the actual height
  if(ringDiam > 0) {
    document.getElementById('mm-height').textContent = `${mm}mm`;
  }
  const size = getRingSizeFromCircumference(mm);

  // Show the size in the interface
  var ring_size_text = el_ls.querySelector('.ringsize-text').getAttribute('data-text');
  document.getElementById('ls-us-yoursize').innerHTML = `Your Size: ${size.uk} (${size.mm}mm)`;
  el_ls.querySelector('.ringsize-number').innerHTML = `Smaller than size ${size.uk} (${size.mm}mm)`;
  var float_mm = parseFloat(mm);

  // Smaller/Larger info
  if(float_mm <= 48.5) {
    el_ls.querySelector('.ringsize-text').innerHTML = `${ring_size_text}`;
    el_ls.querySelector('.ringsize-number').innerHTML = `Smaller than size ${size.uk} (${size.mm}mm)`;
  }
  else if(float_mm >= 71) {
    el_ls.querySelector('.ringsize-text').innerHTML = `${ring_size_text}`;
    el_ls.querySelector('.ringsize-number').innerHTML = `Larger than size ${size.uk} (${size.mm}mm)`;
  }
  else {
    el_ls.querySelector('.ringsize-text').innerHTML = `${ring_size_text}`;
    el_ls.querySelector('.ringsize-number').innerHTML = `${size.uk} (${size.mm}mm)`;
  }
 

  window.localStorage.setItem('ringsize', parseInt(size.uk));

}

function handleRing(scale)
{
  //console.log("handleRing");

  var el_rs = document.getElementById('rs-us');

  const transformation = `scale(${scale})`;
  let currentTranslateX = getTranslateX(ring);
  let currentTranslateY = getTranslateY(ring);

  ring.style.transform = `translate(${currentTranslateX}px, ${currentTranslateY}px) scale(${scale})`;

  const ringDiam = ring.getBoundingClientRect().bottom - ring.getBoundingClientRect().top;
  const mm = (ringDiam / pixelsToMmRatio).toFixed(2);
  
  // Show the actual height
  if(ringDiam > 0) {
    document.getElementById('mm-height-rs').textContent = `${mm}mm`;
  }
  const size = getRingSizeFromDiameter(mm);

  // Show the size in the interface
  var ring_size_text = el_rs.querySelector('.ringsize-text').getAttribute('data-text');
  document.getElementById('rs-us-yoursize').innerHTML = `Your Size: ${size.uk} (${size.mm}mm)`;
  var float_mm = parseFloat(mm);

  // Smaller/Larger info
  if(float_mm <= 14.5) {
    el_rs.querySelector('.ringsize-text').innerHTML = `${ring_size_text}`;
    el_rs.querySelector('.ringsize-number').innerHTML = `Smaller than size ${size.uk} (${size.mm}mm)`;
  }
  else if(float_mm >= 22.8) {
    el_rs.querySelector('.ringsize-text').innerHTML = `${ring_size_text}`;
    el_rs.querySelector('.ringsize-number').innerHTML = `Larger than size ${size.uk} (${size.mm}mm)`;
  }
  else {
    el_rs.querySelector('.ringsize-text').innerHTML = `${ring_size_text}`;
    el_rs.querySelector('.ringsize-number').innerHTML = `${size.uk} (${size.mm}mm)`;
  }

  window.localStorage.setItem('ringsize', parseInt(size.uk));
}


function getRingSizeFromCircumference(circumferenceMM) {
  var diameterMM = (circumferenceMM / Math.PI).toFixed(2);

  return getRingSizeFromDiameter(diameterMM);
}

function getRingSizeFromDiameter(mm) {
  // Get the minimum ring size value
  var min_size = Object.keys(ringSizes[0])[0];

  let size;
  for (let i = 0; i < ringSizes.length; i++) {
    let key = Object.keys(ringSizes[i])[0];
    if (parseFloat(mm) >= parseFloat(key)){
      size = ringSizes[i][key];
      // break;
    }
  }
  if (size) {
    return size;
  } else {
    // If it's smaller than any of the sizes
    return ringSizes[0][min_size];
  }
}

/* ==============================================
2nd Phase 
=============================================== */
function changeSection() {
  console.log('changeSection');
  var buttons = document.querySelectorAll('.button-goto');

  buttons.forEach((button) => {
    button.addEventListener('click', function() {
      var section_id = button.getAttribute('data-goto');
      var closest_el = button.closest('.ring-sizer__item');
      var jsonData = JSON.parse(window.localStorage.getItem('visitedSection'));
      var gotoHistoryButtons = document.querySelectorAll('.button-goto-history');

      closest_el.classList.add('hidden');

      document.getElementById(section_id).classList.remove('hidden');

      if(jsonData) {
        gotoHistoryButtons.forEach((item) => {
          item.classList.remove('hidden');
        });
      }

      /*
      if(section_id == 'step-2a') {
        gotoHistoryButtons.forEach((item) => {
          item.classList.remove('hidden');
        });
      }
      */

      /*
      if(section_id == 'step-5') {
        window.localStorage.removeItem('visitedSection');
      }
      */

      if(section_id == 'step-4a' || section_id == 'step-4b') {
        document.querySelector('.ring-sizer__step-1 button').classList.remove('hidden');
      }
      // Trigger click for minus
      if(section_id == 'step-4a') {
        document.getElementById('ring-minus').click();
      }
      if(section_id == 'step-4b') {
        document.getElementById('line-minus').click();
      }

      // Data Layer Events
      var step_handle = section_id.replace('-','_');
      var event_name = `rs_${step_handle}`;

      //console.log(event_name);

      window.dataLayer.push({
        event: event_name,
        _clear: true
      });

      if(event_name == 'rs_step_4a') {
        window.dataLayer.push({
          event: 'rs_measure_ring',
          _clear: true
        });
        //console.log('rs_measure_ring');
      }

      if(event_name == 'rs_step_4b') {
        window.dataLayer.push({
          event: 'rs_measure_line',
          _clear: true
        });
        //console.log('rs_measure_line');
      }

    });
  });
}

function storeVisitedSectionCookie() {
  document.querySelectorAll('.button-goto-section').forEach((item) => {
    item.addEventListener('click', function() {
      var visitedSectionId = this.closest('.ring-sizer__item').id;
      var visitedSectionCookie = window.localStorage.getItem('visitedSection');

      if (visitedSectionCookie) {
        var arrCookies = JSON.parse(visitedSectionCookie);
        arrCookies.push(visitedSectionId);
        var arrString = JSON.stringify(arrCookies);
        window.localStorage.setItem('visitedSection', arrString);

        //console.log('arrCookies');
        //console.log(arrCookies);
      }
      else {
        var arr = '[' + '"' + visitedSectionId + '"' + ']';
        window.localStorage.setItem('visitedSection', arr);

        //console.log('arr');
        //console.log(arr);
      }
    });
  });
}

function goBackHistory() {
  document.querySelectorAll('.button-goto-history').forEach((button) => {
    button.addEventListener('click', function() {
      var jsonData = JSON.parse(window.localStorage.getItem('visitedSection'));

      if(jsonData.length > 0) {
        document.querySelectorAll('.button-goto-history').forEach((item) => {
          item.classList.remove("hidden");
        });

        var sectionId = jsonData.pop();
        var arrString = JSON.stringify(jsonData);
        button.closest('.ring-sizer__item').classList.add('hidden');

        window.localStorage.setItem('visitedSection', arrString);

        document.getElementById(sectionId).classList.remove('hidden');
      }
      else {
        button.closest('.ring-sizer__item').classList.add('hidden');
        document.getElementById('step-1').classList.remove('hidden');

        this.classList.add('hidden');;
      }

    });
  });
}

function closeTab() {
  document.querySelectorAll('.close-tab').forEach((item) => {
    item.addEventListener('click', function() {
      window.close();

      if(document.referrer) {
        document.getElementById('loading-section').classList.remove('hidden');

        setTimeout(function(){
          window.location.href = document.referrer;
        }, 2000);
        setTimeout(function(){
          window.close();
        }, 3000);
      }
    });
  });
}

function sliderSet(sliderId, sliderIdStr, minusEl, plusEl) {
  console.log(sliderId);
  minusEl.addEventListener('click', function() {
    var currentValue = document.querySelector(sliderIdStr +' .noUi-handle').getAttribute('aria-valuenow');
    currentValue = parseInt(currentValue) - 1;
    sliderId.noUiSlider.set([currentValue]);

    // Make the buttons undisabled and remove hidden classes.
    if(sliderIdStr == '#ring-slider') {
      document.getElementById('select-ring-size').classList.remove("pointer-events-none", "bg-opacity-30");
      removeHiddenForSizes();
    }
    if(sliderIdStr == '#line-slider') {
      document.getElementById('select-line-size').classList.remove("pointer-events-none", "bg-opacity-30");
      removeHiddenForLineSizes();
    }
  });

  plusEl.addEventListener('click', function() {
    var currentValue = document.querySelector(sliderIdStr + ' .noUi-handle').getAttribute('aria-valuenow');
    currentValue = parseInt(currentValue) + 1;
    sliderId.noUiSlider.set([currentValue]);

    removeHiddenForSizes();

    // Make the buttons undisabled and remove hidden classes.
    if(sliderIdStr == '#ring-slider') {
      document.getElementById('select-ring-size').classList.remove("pointer-events-none", "bg-opacity-30");
      removeHiddenForSizes();
    }
    if(sliderIdStr == '#line-slider') {
      document.getElementById('select-line-size').classList.remove("pointer-events-none", "bg-opacity-30");
      removeHiddenForLineSizes();
    }
  });
}

function storeResult() {
  var selectRingButton = document.getElementById('select-ring-size');
  var selectLineButton = document.getElementById('select-line-size');
  var showResult = document.getElementById('show-result');
  var isVisited = false;

  var rsUs = document.getElementById('rs-us');
  var rsUsYoursize = document.getElementById('rs-us-yoursize');

  var lsUs = document.getElementById('ls-us');
  var lsUsYoursize = document.getElementById('ls-us-yoursize');

  selectRingButton.addEventListener('click', function() {
    window.localStorage.setItem('rsUs', rsUs.innerHTML);
    window.localStorage.setItem('rsUsYoursize', rsUsYoursize.innerHTML);
    //window.localStorage.setItem('rsMm', rsMm.innerHTML);
    window.localStorage.setItem('pixelsToMmRatio', pixelsToMmRatio);
    var ring_size = localStorage.getItem('ringsize');

    showResult.innerHTML = localStorage.rsUsYoursize;

    //console.log('Result: ' + ring_size);

    window.dataLayer.push({
      event: 'rs_result',
      value: ring_size,
      _clear: true
    });
  });

  selectLineButton.addEventListener('click', function() {
    window.localStorage.setItem('lsUs', lsUs.innerHTML);
    window.localStorage.setItem('lsUsYoursize', lsUsYoursize.innerHTML);
    //window.localStorage.setItem('lsMm', lsMm.innerHTML);
    window.localStorage.setItem('pixelsToMmRatio', pixelsToMmRatio);
    var ring_size = localStorage.getItem('ringsize');

    showResult.innerHTML = localStorage.lsUsYoursize;

    //console.log('Result: ' + ring_size);

    window.dataLayer.push({
      event: 'rs_result',
      value: ring_size,
      _clear: true
    });
  });
}

// If ring or line size is created before, skip all the steps and show the result right away
// If not selected before, start from the first step.
function showSections() {
  var showResult = document.getElementById('show-result-2');

  if(window.localStorage.getItem('rsUs')) {
    showResult.innerHTML = localStorage.rsUsYoursize;
    document.getElementById('revisited').classList.remove('hidden');
    document.getElementById('resize').classList.remove('hidden');
    document.querySelector('.previous-sizes-title').classList.remove('hidden');
  }
  else if(window.localStorage.getItem('lsUs')) {
    showResult.innerHTML = localStorage.lsUsYoursize;
    document.getElementById('revisited').classList.remove('hidden');
    document.getElementById('resize').classList.remove('hidden');
    document.querySelector('.previous-sizes-title').classList.remove('hidden');
  }
  else {
    //console.log('not visited before');
    window.localStorage.removeItem('visitedSection');
    document.getElementById('intro').classList.remove('hidden');
  }
}

function deleteStoredCookies() {
  document.getElementById('resize').addEventListener('click', function() {
    window.localStorage.removeItem('rsUs');
    window.localStorage.removeItem('lsUs');
  });
}

function moveRing() {
  var ring = document.getElementById('ring');
  var moveUp = document.getElementById('ring-move-up');
  var moveRight = document.getElementById('ring-move-right');
  var moveDown = document.getElementById('ring-move-down');
  var moveLeft = document.getElementById('ring-move-left');
  var countX = 0;
  var countY = 0;
  var currentScale;

  moveUp.addEventListener('click', function() {
    countY--;
  });
  moveRight.addEventListener('click', function() {
    countX++;
  });
  moveDown.addEventListener('click', function() {
    countY++;
  });
  moveLeft.addEventListener('click', function() {
    countX--;
  });

  [moveUp, moveRight, moveDown, moveLeft].forEach(item => {
    item.addEventListener('click', () => {
      currentScale = ring.getBoundingClientRect().width / ring.offsetWidth;
      ring.style.transform = `translate(${countX}px, ${countY}px) scale(${currentScale})`;
    })
  });

}

function getTranslateX(el) {
  var style = window.getComputedStyle(el);
  var matrix = new WebKitCSSMatrix(style.transform);
  return matrix.m41;
}

function getTranslateY(el) {
  var style = window.getComputedStyle(el);
  var matrix = new WebKitCSSMatrix(style.transform);
  return matrix.m42;
}

function determineDevice() {
  var ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
      return "tablet";
    }
    else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
      return "mobile";
    }
    return "desktop";
}

function storeCurrentSectionClass() {
  document.querySelectorAll('.ring-sizer__item').forEach( item => {
    if(!item.classList.contains('hidden')) {
      window.localStorage.setItem('visited-section-id', item.id);
    }
  });
}

function removeHiddenForSizes() {
  document.getElementById('mm-height-rs').classList.remove('hidden');
  document.getElementById('rs-us').classList.remove('hidden');
}

function removeHiddenForLineSizes() {
  document.getElementById('mm-height').classList.remove('hidden');
  document.getElementById('ls-us').classList.remove('hidden');
}


var detDevice = determineDevice();
setTimeout(function (){
  if(detDevice == 'mobile') {
    // Init functions
    changeSection();
    storeResult();
    showSections();
    deleteStoredCookies();
    moveRing();
    closeTab();
    storeVisitedSectionCookie();
    goBackHistory();
    sliderSet(ringSlider, '#ring-slider', document.getElementById('ring-minus'), document.getElementById('ring-plus'));
    sliderSet(lineSlider, '#line-slider', document.getElementById('line-minus'), document.getElementById('line-plus'));
    sliderSet(calibrationSlider, '#calibrate-slider', document.getElementById('calibrate-minus'), document.getElementById('calibrate-plus'));
  }
  else {
    document.getElementById('determine-device').classList.remove('hidden');
  }
            
}, 1000);
